import axios from 'axios'

async function beforeEnter(to, from, next) {
    try {
        const { token } = to.params
        const response = await axios.get(`onboarding/admin/${token}`)
        const admin = response.data

        if (Object.keys(admin).length === 0) {
            next('login')
        } else {
            next()
        }
    } catch (e) {
        next('login')
    }
}

export default beforeEnter
